import { useEffect, useRef, useState } from 'react';
import './customScrollbar.css';

function CustomScrollbar({ scrollRef }) {
  const containerRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [scrollHeight, setScrollHeight] = useState(0);
  const scrollHeightRef = useRef(0);
  const [scrollAreaHeight, setScrollAreaHeight] = useState(0);
  useEffect(() => {
    if (!scrollRef.current) return;
    function scrollHandler() {
      if (!scrollRef.current || !containerRef.current) return;
      const scrollY = scrollRef.current.scrollTop;
      const maxScroll = scrollRef.current.scrollHeight - scrollRef.current.clientHeight;
      const scrollValue = (scrollY / maxScroll) * 100;
      const scrollPx = scrollValue * containerRef.current.clientHeight * 0.01;
      setScrollTop(scrollPx - scrollHeightRef.current * scrollValue * 0.01);
    }
    scrollRef.current.addEventListener('scroll', scrollHandler);
  }, []);

  useEffect(() => {
    if (!scrollRef.current || !containerRef.current) return;
    function setSize() {
      setScrollHeight(
        (scrollRef.current.clientHeight / scrollRef.current.scrollHeight) * containerRef.current.clientHeight,
      );
      scrollHeightRef.current =
        (scrollRef.current.clientHeight / scrollRef.current.scrollHeight) * containerRef.current.clientHeight;
      setScrollAreaHeight(containerRef.current.clientHeight);
    }
    setSize();
    window.addEventListener('resize', setSize);
    return () => {
      window.removeEventListener('resize', setSize);
    };
  }, []);
  return (
    <div className={'customscrollbar container'} ref={containerRef}>
      <div
        className={'customscrollbar scrollStick'}
        style={{
          top: `max(${scrollTop}px, 0px)`,
          bottom: `max(${scrollAreaHeight - scrollHeight - scrollTop}px, 0px)`,
        }}
      ></div>
    </div>
  );
}
export default CustomScrollbar;

